import React, { useContext, useEffect, useState } from 'react';
import { DatePicker, TimePicker } from 'antd';
import dayjs from 'dayjs';
import { LangContext } from '../../contexts/langContext';
import { SocialContext } from '../../contexts/socialContext';
import { StateContext } from '../../contexts/stateContext';
import {
  convertGMTtoDateTime,
  defaultDate,
  defaultOffset,
  defaultTime,
  getMonth
} from '../utilsDesign';
import { City } from './City';
import { Time } from './Time';
import { Button } from './Button';
import { WithVersion } from './VersionToggler';

const TIME_FORMAT = 'HH:mm';

const timeFromDob = (dob) => {
  if (!dob || typeof dob !== 'string' || !dob.includes('T')) return '';
  return dob.split('T')[1].substring(0, 5);
};

const midpointTime = (start, end) => {
  if (!start || !end) return null;
  let to = end;
  if (to.isBefore(start)) to = to.add(1, 'day');
  return start.add(Math.round(to.diff(start) / 2), 'millisecond');
};

const toDob = (dateValue, timeValue) => {
  const hhmm = typeof timeValue === 'string' ? timeValue : timeValue.format(TIME_FORMAT);
  return `${dateValue}T${hhmm}:00`;
};

const rangeFromTime = (timeStr) => {
  const start = timeStr && dayjs(timeStr, TIME_FORMAT).isValid()
    ? dayjs(timeStr, TIME_FORMAT)
    : dayjs('12:00', TIME_FORMAT);
  return [start, start.add(10, 'minute')];
};

const hoursList = Array.from({ length: 24 }, (_, hour) => hour);
const minutesList = Array.from({ length: 60 }, (_, minute) => minute);

const resolveTimeRange = (nextStart, nextEnd, prevEnd, changed) => {
  if (!nextStart) return null;
  if (changed === 'start') {
    if (prevEnd && prevEnd.isAfter(nextStart)) return [nextStart, prevEnd];
    return [nextStart, nextStart.add(10, 'minute')];
  }
  if (!nextEnd || !nextEnd.isAfter(nextStart)) {
    return [nextStart, nextStart.add(10, 'minute')];
  }
  return [nextStart, nextEnd];
};

const disabledRangeTime = (now, type) => {
  if (type !== 'end' || !now) return {};
  return {
    disabledHours: () => hoursList.filter((hour) => hour < now.hour()),
    disabledMinutes: (selectedHour) => {
      if (selectedHour < now.hour()) return minutesList;
      if (selectedHour > now.hour()) return [];
      return minutesList.filter((minute) => minute <= now.minute());
    },
  };
};



export function CityDateTime(props) {

  const {
    publicUser = false,
    avatarToken,
    avatar = {},
    avatarDate,
    avatarTime,
    avatarCityId,
    avatarOffset,
    showForm = false,
    setShowForm = () => void (0),
    updateHandler = () => void (0),
    citySearchActive = false,
    updatingAva = false,
    cantHide
  } = { ...props }

  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) };
  const $ui = context.$ui;

  const { language } = context || 'en';

  const onOk = (value) => {
    // console.log('onOk: ', value);
  };


  const dateFormatList = [
    'MMM DD',
    'MMMM DD',
    'DD MMM',
    'MMMM DD',
    'DD/MM',
    'DD/MM',
    'DD-MM',
    'DD-MM'
  ];



  const yearFormatList = [
    'YYYY',
  ];


  const format = 'HH:mm';
  const [date, setDate] = useState(avatar.dob ? convertGMTtoDateTime(avatar.dob, 0, 'date') : '');
  const [time, setTime] = useState(avatar.dob ? convertGMTtoDateTime(avatar.dob, 0, 'time') : '');
  const [offset, setOffset] = useState(
    avatar?.aggr?.city?.offset ?? avatarOffset ?? defaultOffset
  );
  const [cityId, setCityId] = useState(
    avatar?.aggr?.city?.id ?? avatarCityId ?? avatar?.city_id ?? null
  );
  const [cityObj, setCityObj] = useState(avatar?.aggr?.city ?? {});
  const [focused, setFocused] = useState();


  useEffect(() => {
    if (avatar?.dob) {
      setDate(convertGMTtoDateTime(avatar.dob, 0, 'date'));
      setTime(convertGMTtoDateTime(avatar.dob, 0, 'time'));
    } else {
      setDate(avatarDate ?? defaultDate);
      setTime(avatarTime ?? '');
      setCityObj({});
    }
    if (avatar?.aggr?.city) {
      setOffset(avatar.aggr.city.offset);
      setCityId(avatar.aggr.city.id);
      setCityObj(avatar.aggr.city);
    } else {
      setOffset(avatarOffset ?? defaultOffset);
      setCityId(avatarCityId ?? avatar.city_id ?? null);
    }
  }, [avatar?.token, avatar?.dob])

  useEffect(() => {
    if (avatar?.aggr?.city?.id) {
      setOffset(avatar.aggr.city.offset);
      setCityId(avatar.aggr.city.id);
      setCityObj(avatar.aggr.city);
    }
  }, [avatar?.aggr?.city?.id])


  // const [city, setCity] = useState({ value: '1', label: '1' })
  // const [city, setCity] = useState({})

  const [showFormInner, setShowFormInner] = useState(showForm)


  const [changed, setChanged] = useState(false);
  const [submittable, setSubmittable] = useState(false);

  const [uncertain, setUncertain] = useState(Boolean(avatar?.dob_start && avatar?.dob_end));
  const [timeRange, setTimeRange] = useState(() => {
    if (avatar?.dob_start && avatar?.dob_end) {
      const start = timeFromDob(avatar.dob_start);
      const end = timeFromDob(avatar.dob_end);
      if (start && end) return [dayjs(start, TIME_FORMAT), dayjs(end, TIME_FORMAT)];
    }
    return null;
  });
  const [rangeOpen, setRangeOpen] = useState(false);

  useEffect(() => {
    if (avatar?.dob_start && avatar?.dob_end) {
      const start = timeFromDob(avatar.dob_start);
      const end = timeFromDob(avatar.dob_end);
      setUncertain(true);
      setTimeRange(start && end
        ? [dayjs(start, TIME_FORMAT), dayjs(end, TIME_FORMAT)]
        : rangeFromTime(timeFromDob(avatar.dob)));
    } else {
      setUncertain(false);
      setTimeRange(null);
    }
  }, [avatar?.token, avatar?.dob, avatar?.dob_start, avatar?.dob_end]);


  useEffect(() => {
    // console.log('avatar.dob = ', avatar.dob);
    // console.log('time ===== ', time);
    const timeDJ = dayjs(`${time}`, 'HH:mm');
    // console.log('time DJ ===== ', timeDJ);
  }, [time])


  useEffect(() => {
   if (showForm !== showFormInner) {
    setShowFormInner(showForm)
   } 
  }, [showForm, avatar])

  useEffect(() => {
    setShowForm(showFormInner)
  }, [showFormInner])

  useEffect(() => {
    if (!showFormInner || updatingAva) setRangeOpen(false);
  }, [showFormInner, updatingAva])

  // useEffect(() => {
  //   if (!context.state.peoplePanel && avatar.design.id === 'dummy' && avatar.my) {
  //     context.setState.setCalcShown(true)
  //   } else {
  //     context.setState.setCalcShown(false)
  //     setShowFormInner(false)
  //     context.setState.setCitySearchActive(false)
  //   }
  // }, [context.state.peoplePanel, avatar])

  useEffect(() => {
    const origDate = avatar?.dob
      ? convertGMTtoDateTime(avatar.dob, 0, 'date')
      : (avatarDate ?? defaultDate);
    const origTime = avatar?.dob
      ? convertGMTtoDateTime(avatar.dob, 0, 'time')
      : (avatarTime ?? '');
    const origCityId = avatar?.city_id ?? avatarCityId ?? null;

    const origStart = timeFromDob(avatar?.dob_start);
    const origEnd = timeFromDob(avatar?.dob_end);
    const hadRange = Boolean(origStart && origEnd);
    const curStart = timeRange?.[0]?.format(TIME_FORMAT) || '';
    const curEnd = timeRange?.[1]?.format(TIME_FORMAT) || '';

    if (uncertain) {
      setChanged(
        cityId !== origCityId
        || date !== origDate
        || !hadRange
        || curStart !== origStart
        || curEnd !== origEnd
      );
      setSubmittable(Boolean(cityId && date && timeRange?.[0] && timeRange?.[1]));
    } else {
      setChanged(
        cityId !== origCityId
        || date !== origDate
        || time !== origTime
        || hadRange
      );
      setSubmittable(Boolean(cityId && date && time));
    }
  }, [cityId, date, time, timeRange, uncertain, avatar?.dob, avatar?.dob_start, avatar?.dob_end, avatar?.city_id, avatarDate, avatarTime, avatarCityId])


  // useEffect(() => {
  //   setCityId(avatarCityId ? avatarCityId : null)
  //   setDate(avatarDate ? avatarDate : defaultDate)
  //   setTime(avatarTime ? avatarTime : defaultTime)
  //   if (!avatar.design || avatar.design.id === 'dummy' && avatar.my && !uncertain) {
  //     context.setState.setCalcShown(true)
  //   } else {
  //     if (avatar.design.id !== 'dummy' && !uncertain) context.setState.setCalcShown(false)
  //   }
  // }, [avatar]);

  // useEffect(() => {
  //   context.state.calcShown !== showFormInner && setShowFormInner(context.state.calcShown);
  // }, [context.state.calcShown]);

  useEffect(() => {
    if (avatarDate) setDate(avatarDate);
  }, [avatarDate]);

  useEffect(() => {
    if (avatarTime) setTime(avatarTime);
  }, [avatarTime]);

  useEffect(() => {
    if (avatarOffset && avatarOffset !== offset) {
      setOffset(avatarOffset)
    }
  }, [avatarOffset]);

  useEffect(() => {
    // console.log('avatarOffset = ', offset);
  }, [avatarOffset]);
  useEffect(() => {
    // console.log('offset = ', offset);
  }, [offset]);




  const options = [];
  for (let i = 10; i < 36; i++) {
    options.push({
      value: i.toString(36) + i,
      label: i.toString(36) + i,
    });
  }



  const handleNewDate = (dontHideCalc) => {
    setRangeOpen(false);
    if (!uncertain && dontHideCalc) {
      setShowFormInner(false)
      setShowForm(false)
      // context.setState.setCalcShown(false)
      // context.setState.setCitySearchActive(false)
    }

    // const { iso } = convertGMTtoDateTime(`${date}T${time}`, 0)

    const newData = {
      // ...avatar,
      token: avatar.token,
      // dob: adjustUTCByOffset(convertDateTimeToGMT(date, time, 0), offset),
      // dob: iso,
      dob: `${date}T${time}:00`,
      city_id: cityId,
      city: cityObj
    }

    if (uncertain && timeRange?.[0] && timeRange?.[1]) {
      const mid = midpointTime(timeRange[0], timeRange[1]);
      newData.dob = toDob(date, mid);
      newData.dob_start = toDob(date, timeRange[0]);
      newData.dob_end = toDob(date, timeRange[1]);
    } else if (avatar?.dob_start || avatar?.dob_end) {
      newData.dob_start = '';
      newData.dob_end = '';
    }

    console.log('newData = ', newData);
    updateHandler(newData)
  }

  const enterUncertain = () => {
    const nextRange = timeRange?.[0] && timeRange?.[1] ? timeRange : rangeFromTime(time);
    setTimeRange(nextRange);
    const mid = midpointTime(nextRange[0], nextRange[1]);
    if (mid) setTime(mid.format(TIME_FORMAT));
    setUncertain(true);
    setRangeOpen(true);
  };

  const exitUncertain = () => {
    if (timeRange?.[0] && timeRange?.[1]) {
      const mid = midpointTime(timeRange[0], timeRange[1]);
      if (mid) setTime(mid.format(TIME_FORMAT));
    }
    setUncertain(false);
    setRangeOpen(false);
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if the click is outside the component
      if (!event.target.closest(".x0_search") && !event.target.closest(".__calcshown")) {
        // context.setState.setCalcShown(false)
        // avatar.design.id !== 'dummy' && context.setState.setCalcShown(false)
      }

    };

    document.addEventListener("click", handleClickOutside);
    // document.addEventListener("mousemove", handleMouseMove);

    return () => {
      document.removeEventListener("click", handleClickOutside);
      // document.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);



  const applyNewDate = (dateString) => {
    // const date = new Date(dateString)
    const processedDate = (prevDate) => {
      const year = String(prevDate.split('-')[0]);
      const month = String(prevDate.split('-')[1]).padStart(2, '0');
      const day = prevDate.split('-')[2].split('T')[0];
      return `${year}-${month}-${day}`;
    }
    const processedTime = (prevDate) => {
      const hours = String(prevDate.split('T')[1]).split(':')[0]
      const minutes = String(prevDate.split('T')[1]).split(':')[1]
      // console.log('hours = ', hours);
      // console.log('minutes = ', minutes);
      return `${hours}:${minutes}`;
    }
    const newDate = processedDate(dateString)
    const newTime = processedTime(dateString)
    // console.log('processedDate = ', newDate);
    // console.log('processedTime(dateString) = ', newTime);
    setDate(newDate)
    setTime(newTime)

    const newData = {
      token: avatar.token,
      dob: `${newDate}T${newTime}:00`,
      city_id: cityId,
    }
    updateHandler(newData);
    setUncertain(false);

  }

  const monthRender = (current, info) => {
    return <div className="_f100 _fgap0 _tl _rel _fm"
      style={{ height: '2.4em' }}
    >
      <div className="x_time_hover">
      </div>
      <span style={{ paddingLeft: '0.4em', width: '2em', flexShrink: 0 }}>{current.$M + 1}</span> <b className='_tl' style={{ width: '10em' }}>{getMonth(current.$M, language)}</b>
    </div>
  }

  const monthCellRender = (current, info) => {
    if (info.type !== 'date') {
      // return `${current.$M + 1} ${info.originNode}`;
      return <div className="_f100 _fgap0 _tl _rel _fm"
        style={{ height: '2.4em' }}
      >
        <div className="x_time_hover">
        </div>
        <span style={{ paddingLeft: '0.4em', width: '2em', flexShrink: 0 }}>{current.$M + 1}</span> <b className='_tl' style={{ width: '10em' }}>{getMonth(current.$M, language)}</b>
      </div>

    }
    if (typeof current === 'number' || typeof current === 'string') {
      return <div className="ant-picker-cell-inner">{current}</div>;
    }

    const style = { width: '12em' }
    return (
      <div
        // className="x_time_drop_item ant-picker-cell-inner"
        className="x_time_drop_item"
        style={current.date() === 1 ? style : {}}>
        {current.date()}
      </div>
    );
  };


  const formatMonth = (value) => {
    return getMonth(value.month(), language)
  };



  return (
    <>



      <div
        onClick={(e) => {
          e.stopPropagation();
          ((avatar && avatar.design && avatar.design.id !== 'dummy') || publicUser) && 
          setShowForm(false) &&
          setShowFormInner(false)
        }}
        className={showFormInner
          ? "x_dropdown_menu_z active" 
          : "x_dropdown_menu_z inact"}
      />

      <div 
        style={{
          opacity: !showFormInner || updatingAva ? 0 : 1,
        }}
        className={!showFormInner ? "x0_search_inner done" : `x0_search_inner ${citySearchActive ? 'focused-city' : ''}`}>
          <div className={!showFormInner ? `x0_omnifield0 done` : `x0_omnifield0 ${citySearchActive ? 'focused-city' : ''}`}>

            <div className={`x_calc_datetime ${focused === 'city' ? 'focused-city' : ''}`}
            >
              {/* <City
                  handleSelect={setCity}
                /> */}

              <City
                hint={true}
                handleCityFocused={true}
                autoFocus={true}
                className='x_input--city'
                value={cityId}
                city={cityObj?.id ? cityObj : avatar?.aggr?.city}
                handleTimeOffset={setOffset}
                handleCityId={setCityId}
                handleCityObj={setCityObj}
                avatar={avatar}
              />

              {/* {city && <CityDrop one={city} />} */}

              {/* <SelectCity /> */}

            </div>

            <div className={`x_calc_form_section ${context.state.citySearchActive ? 'focused-city' : ''} `}>
              <div
                className={`x_calc_datetime x_calc_datetime--datetime`}
              >



                <div className="mobile_v_no"
                >



                  <DatePicker
                    picker="year"
                    suffixIcon={false}
                    variant={'borderless'}
                    changeOnBlur={true}
                    value={dayjs().year(date ? date.split('-')[0] : '1991')}
                    // value={dob}
                    format={yearFormatList}
                    // style={{ width: 64 }}
                    className={`x_input x_input--year __calcshown`}
                    onChange={(result) => {
                      // result = formatDate(result)
                      result && setDate((prevDate) => {
                        const year = result['$y'];
                        const month = String(prevDate.split('-')[1]).padStart(2, '0');
                        const day = String(prevDate.split('-')[2]).padStart(2, '0');
                        return `${year}-${month}-${day}`;
                      });
                    }}
                    // onOk={onOk}
                    // size="large"
                    showToday={false}
                    allowClear={false}
                    // bordered={false}
                    inputReadOnly={true}
                    onPressEnter={(e) => {
                      // e.preventDefault()
                      // // Handle the Enter key press here
                      // // Manually update the date state when Enter is pressed
                      // setDate((currentDate) => {
                      //   // currentDate = formatDate(currentDate)
                      //   if (dayjs(currentDate).isValid()) {
                      //     return currentDate;
                      //   }
                      //   // If the current date is not valid, you can provide a default value or handle it as needed
                      //   // return defacaultValue; // Replace 'defaultValue' with your default date
                      // });
                    }}
                  // open={false} // Controlled open state
                  // onOpenChange={handleOpenChange} // Handle open/close events
                  />
                </div>


                <div className="mobile_v_yes"
                >
                  <DatePicker
                    picker="year"
                    placement={'topLeft'}
                    suffixIcon={false}
                    variant={'borderless'}
                    changeOnBlur={true}
                    value={dayjs().year(date ? date.split('-')[0] : '1991')}
                    // value={dob}
                    format={yearFormatList}
                    // style={{ width: 64 }}
                    className={`x_input x_input--year __calcshown`}
                    onChange={(result) => {
                      // result = formatDate(result)
                      result && setDate((prevDate) => {
                        const year = result['$y'];
                        const month = String(prevDate.split('-')[1]).padStart(2, '0');
                        const day = String(prevDate.split('-')[2]).padStart(2, '0');
                        return `${year}-${month}-${day}`;
                      });
                    }}
                    onOk={onOk}
                    // size="large"
                    showToday={false}
                    allowClear={false}
                    // bordered={false}
                    inputReadOnly={true}
                    onPressEnter={(e) => {
                      e.preventDefault()
                      // Handle the Enter key press here
                      // Manually update the date state when Enter is pressed
                      setDate((currentDate) => {
                        // currentDate = formatDate(currentDate)
                        if (dayjs(currentDate).isValid()) {
                          return currentDate;
                        }
                        // If the current date is not valid, you can provide a default value or handle it as needed
                        // return defacaultValue; // Replace 'defaultValue' with your default date
                      });
                    }}
                  // open={false} // Controlled open state
                  // onOpenChange={handleOpenChange} // Handle open/close events
                  />
                </div>





                <div className="mobile_v_no"
                >
                  <DatePicker
                    picker="month"
                    cellRender={monthCellRender}
                    suffixIcon={false}
                    inputReadOnly={true}
                    popupClassName={'dateselector'}
                    className={`x_input x_input--month __calcshown`}
                    placement={'bottomLeft'}
                    // size={'large'}
                    // variant={'filled'}
                    variant={'borderless'}
                    changeOnBlur={true}
                    // defaultValue={dayjs(date, 'YYYY-MM-DD').format('DD/MMM/YYYY')}
                    value={dayjs(date)}
                    // value={dob}
                    // format={['MMMM']}
                    format={(value) => formatMonth(value)}

                    onChange={(result) => {
                      if (result) {
                        // Adjust for 0-indexed month and ensure two-digit formatting
                        const month = String(result['$M'] + 1).padStart(2, '0');
                        const day = String(result['$D']).padStart(2, '0');
                        // Use the original year from prevDate
                        setDate((prevDate) => `${prevDate.split('-')[0]}-${month}-${day}`);
                      }
                    }}
                    onOk={onOk}
                    // style={{ width: 80 }}
                    showToday={false}
                    allowClear={false}
                    // bordered={false}
                    onPressEnter={(e) => {
                      e.preventDefault()
                      // Handle the Enter key press here
                      // Manually update the date state when Enter is pressed
                      setDate((currentDate) => {
                        // currentDate = formatDate(currentDate)
                        if (dayjs(currentDate).isValid()) {
                          return currentDate;
                        }
                        // If the current date is not valid, you can provide a default value or handle it as needed
                        // return defacaultValue; // Replace 'defaultValue' with your default date
                      });
                    }}
                  // onChange={onChange}
                  />
                </div>
                <div className="mobile_v_yes"
                >
                  <DatePicker
                    picker="month"
                    cellRender={monthCellRender}
                    suffixIcon={false}
                    inputReadOnly={true}
                    popupClassName={'dateselector'}
                    className={`x_input x_input--month __calcshown`}
                    placement={'topLeft'}
                    // size={'large'}
                    // variant={'filled'}
                    variant={'borderless'}
                    changeOnBlur={true}
                    // defaultValue={dayjs(date, 'YYYY-MM-DD').format('DD/MMM/YYYY')}
                    value={dayjs(date)}
                    // value={dob}
                    // format={['MMMM']}
                    format={(value) => formatMonth(value)}

                    onChange={(result) => {
                      if (result) {
                        // Adjust for 0-indexed month and ensure two-digit formatting
                        const month = String(result['$M'] + 1).padStart(2, '0');
                        const day = String(result['$D']).padStart(2, '0');
                        // Use the original year from prevDate
                        setDate((prevDate) => `${prevDate.split('-')[0]}-${month}-${day}`);
                      }
                    }}
                    onOk={onOk}
                    // style={{ width: 80 }}
                    showToday={false}
                    allowClear={false}
                    // bordered={false}
                    onPressEnter={(e) => {
                      e.preventDefault()
                      // Handle the Enter key press here
                      // Manually update the date state when Enter is pressed
                      setDate((currentDate) => {
                        // currentDate = formatDate(currentDate)
                        if (dayjs(currentDate).isValid()) {
                          return currentDate;
                        }
                        // If the current date is not valid, you can provide a default value or handle it as needed
                        // return defacaultValue; // Replace 'defaultValue' with your default date
                      });
                    }}
                  // onChange={onChange}
                  />
                </div>



                <div className="mobile_v_no"
                >
                  <DatePicker
                    suffixIcon={false}
                    inputReadOnly={true}
                    popupClassName={'dateselector'}
                    className={`x_input x_input--day __calcshown`}
                    placement={'bottomLeft'}
                    // size={'large'}
                    // variant={'filled'}
                    variant={'borderless'}
                    changeOnBlur={true}
                    // defaultValue={dayjs(date, 'YYYY-MM-DD').format('DD/MMM/YYYY')}
                    value={dayjs(date)}
                    // value={dob}
                    // format={dateFormatList}
                    format={['DD']}

                    onChange={(result) => {
                      if (result) {
                        // Adjust for 0-indexed month and ensure two-digit formatting
                        const month = String(result['$M'] + 1).padStart(2, '0');
                        const day = String(result['$D']).padStart(2, '0');
                        // Use the original year from prevDate
                        setDate((prevDate) => `${prevDate.split('-')[0]}-${month}-${day}`);
                      }
                    }}
                    onOk={onOk}
                    // style={{ width: 52 }}
                    showToday={false}
                    allowClear={false}
                    // bordered={false}
                    onPressEnter={(e) => {
                      e.preventDefault()
                      // Handle the Enter key press here
                      // Manually update the date state when Enter is pressed
                      setDate((currentDate) => {
                        // currentDate = formatDate(currentDate)
                        if (dayjs(currentDate).isValid()) {
                          return currentDate;
                        }
                        // If the current date is not valid, you can provide a default value or handle it as needed
                        // return defacaultValue; // Replace 'defaultValue' with your default date
                      });
                    }}
                  // open={false} // Controlled open state
                  // onOpenChange={handleOpenChange} // Handle open/close events
                  />
                </div>
                <div className="mobile_v_yes"
                >
                  <DatePicker
                    suffixIcon={false}
                    inputReadOnly={true}
                    popupClassName={'dateselector'}
                    className={`x_input x_input--day __calcshown`}
                    placement={'topLeft'}
                    // size={'large'}
                    // variant={'filled'}
                    variant={'borderless'}
                    changeOnBlur={true}
                    // defaultValue={dayjs(date, 'YYYY-MM-DD').format('DD/MMM/YYYY')}
                    value={dayjs(date)}
                    // value={dob}
                    // format={dateFormatList}
                    format={['DD']}

                    onChange={(result) => {
                      if (result) {
                        // Adjust for 0-indexed month and ensure two-digit formatting
                        const month = String(result['$M'] + 1).padStart(2, '0');
                        const day = String(result['$D']).padStart(2, '0');
                        // Use the original year from prevDate
                        setDate((prevDate) => `${prevDate.split('-')[0]}-${month}-${day}`);
                      }
                    }}
                    onOk={onOk}
                    // style={{ width: 52 }}
                    showToday={false}
                    allowClear={false}
                    // bordered={false}
                    onPressEnter={(e) => {
                      e.preventDefault()
                      // Handle the Enter key press here
                      // Manually update the date state when Enter is pressed
                      setDate((currentDate) => {
                        // currentDate = formatDate(currentDate)
                        if (dayjs(currentDate).isValid()) {
                          return currentDate;
                        }
                        // If the current date is not valid, you can provide a default value or handle it as needed
                        // return defacaultValue; // Replace 'defaultValue' with your default date
                      });
                    }}
                  // open={false} // Controlled open state
                  // onOpenChange={handleOpenChange} // Handle open/close events
                  />
                </div>

                {/* <DatePicker defaultValue={defaultValue} onChange={onChange} /> */}

                {/* </Space> */}

                <div className="x_time00">
                  {uncertain ? (
                    <TimePicker.RangePicker
                      format={TIME_FORMAT}
                      value={timeRange}
                      open={rangeOpen}
                      onOpenChange={setRangeOpen}
                      order={false}
                      disabledTime={(now, type) => disabledRangeTime(timeRange?.[0], type)}
                      onCalendarChange={(range, _strings, info) => {
                        const next = resolveTimeRange(
                          range?.[0],
                          range?.[1],
                          timeRange?.[1],
                          info?.range
                        );
                        if (!next) return;
                        setTimeRange(next);
                        const mid = midpointTime(next[0], next[1]);
                        if (mid) setTime(mid.format(TIME_FORMAT));
                      }}
                      onChange={(range) => {
                        const next = resolveTimeRange(
                          range?.[0],
                          range?.[1],
                          timeRange?.[1],
                          range?.[0] && timeRange?.[0] && !range[0].isSame(timeRange[0], 'minute')
                            ? 'start'
                            : 'end'
                        );
                        if (!next) return;
                        setTimeRange(next);
                        const mid = midpointTime(next[0], next[1]);
                        if (mid) setTime(mid.format(TIME_FORMAT));
                      }}
                      suffixIcon={false}
                      variant="borderless"
                      allowClear={false}
                      inputReadOnly
                      changeOnBlur
                      needConfirm={false}
                      showNow={false}
                      className="x_input x_input--time-range"
                      popupClassName="x_time_range_popup"
                      renderExtraFooter={() => (
                        <WithVersion><button
                          type="button"
                          variant="borderless"
                          className="x_time_dont_know x_time_dont_know--back"
                          aria-label={$ui('time_i_know')}
                          onClick={exitUncertain}
                          >
                            ←
                          </button>
                        </WithVersion>
                      )}
                    />
                  ) : (
                    <Time
                      avatar={avatar}
                      onDontKnow={enterUncertain}
                      onChange={(nextTime) => {
                        setTime(nextTime);
                      }}
                      value={time ? dayjs(`${time}`, 'HH:mm') : null}
                      shown={!context.state.calcShown ? false : null}
                    />
                  )}


                  {/* TODO: uncertain */}
                  {/*
                  {cityId && <div className={uncertain ? "x_time_uncertain active" : "x_time_uncertain"}
                    onClick={() => {
                      setUncertain(prev => !prev)
                      if (avatar.design.id === 'dummy') handleNewDate('dontHideCalc')
                    }}
                  >
                    {uncertain && <div className="x_time_uncertain_clear"><div className="t_icon t_icon--40"><div>cancel</div></div></div>}
                    <div className="x_time_uncertain_ico">🤷‍♂️</div>
                  </div>} */}

                </div>

                {/* <TimePicker
                  popupClassName={'timeselector'}
                  inputReadOnly={true}
                  suffixIcon={false}
                  changeOnBlur={true}
                  variant={'borderless'}
                  className='x_input x_input--time'
                  // onOpenChange={handleOpenChangeTime} // Handle open/close events
                  // defaultValue={dayjs('13:00', format)}
                  value={dayjs(`${time}`, 'HH:mm')}
                  format={format}
                  // style={{ width: 64 }}
                  // onChange={(event) => setTime(event.target.value)}
                  onChange={(time) => {
                    const formattedTime = `${time['$H'].toString().padStart(2, '0')}:${time['$m'].toString().padStart(2, '0')}`;
                    setTime(formattedTime);
                  }}
                  onClose={(time) => {
                    const formattedTime = `${time['$H'].toString().padStart(2, '0')}:${time['$m'].toString().padStart(2, '0')}`;
                    setTime(formattedTime);
                  }}
                  onSelect={(time) => {
                    const formattedTime = `${time['$H'].toString().padStart(2, '0')}:${time['$m'].toString().padStart(2, '0')}`;
                    setTime(formattedTime);
                  }}
                  changeOnScroll={true}
                  // size="large"
                  showNow={false}
                  allowClear={false}

                  // bordered={false}
                /> */}



                {/* <div className="x_button_add active">
                <div>🤷‍♂️</div>
              </div> */}




              </div>


              {changed && submittable && <div className={`x_button x_button--submit `}
                onClick={handleNewDate}
              >
                <div className="mobile_v_yes">
                  {$ui('cta_calculate_short')}
                </div>
                <div className="t_icon t_icon--40">
                  chevron_right
                </div>
              </div>}

              {changed && !submittable && <div className={`x_button x_button--submit x_button--calcsub x_button--ghost mobile_v_no`}
                onClick={() => {
                  if (!avatar.design || avatar.design.id !== 'dummy') {
                    setDate(avatarDate)
                    setTime(avatarTime)
                    setCityId(avatarCityId)
                  }
                  context.setState.setCalcShown(false);
                  setShowFormInner(false);
                }}
              >
                <div className="t_icon t_icon--40 mobile_v_no">
                  close
                </div>
                <div className="mobile_v_yes">
                  {$ui('cta_calculate_cancel')}
                </div>
              </div>}

              {!changed && avatar.design !== 'dummy' && <div className="x_button x_button--notchanged"
                onClick={(e) => {
                  e.preventDefault();
                  context.setState.setCalcShown(false);
                  setShowFormInner(false);
                }}
              >
                <div className="t_icon t_icon--40">
                  done
                </div>
              </div>}
            </div>


          </div>
        </div>



    </>
  )
}